import { Tr, Td, Row, Col } from "@visa/vds"
import { VSTS_TITLE, EXPIRATION_ALERT, getExpirationAlertIcon, DASHBOARD_STAFF_VSTS_SUBSCRIPTION_TABLE_HEADERS, DASHBOARD_USER_VSTS_SUBSCRIPTION_TABLE_HEADERS, getCardAlertType, renderSubtitle, VSTS_SUBTITLES } from "_constants/DashboardConstants"
import { DateHelper } from "_helpers/DateHelper"
import { LibraryHelper } from "_helpers/LibraryHelper"
import MCSConfirmDialog from "components/MCSConfirmDialog"
import React, { useContext, useEffect, useState } from "react"
import DashboardAccordion from "../DashboardAccordion"
import ProductCertificationFootnotes from "./ProductCertificationFootnotes"
import VstsAccordionActionItems from "./VstsAccordionActionItems"
import { LibraryPostType } from "_constants/LibraryConstants"
import { LibraryPostFileClickAction } from "_constants/GlobalConstants"
import MCSPagedTable from "components/MCSPagedTable"
import { useAuthContextUser } from "context/AuthContext"
import { DashboardUserApi, DashboardStaffApi } from "services/dashboard.service"
import { trackPromise } from "react-promise-tracker"
import { GlobalAlertContext } from "context/GlobalAlertContext";

const PAGE_SIZE = 10

const VstsSubcriptionsAccordion = (props) => {
    let {
        selectedBid,
        setPageError,
    } = props

    const alertContext = useContext(GlobalAlertContext);
    const user = useAuthContextUser();

    const isExternalUser = user && user.isExternalUser;
    const vstsTableHeaders = isExternalUser ? DASHBOARD_USER_VSTS_SUBSCRIPTION_TABLE_HEADERS : DASHBOARD_STAFF_VSTS_SUBSCRIPTION_TABLE_HEADERS
    const API = isExternalUser ? DashboardUserApi : DashboardStaffApi

    const [vstsLibraryPost, setVstsLibraryPost] = useState(null);
    const [vstsButtonState, setVstsButtonState] = useState(null);
    const [vstsSubscriptions, setVstsSubscriptions] = useState(null);
    const [confirmDialog, setConfirmDialog] = useState(null);
    const [subtitle, setSubtitle] = useState(null)
    const [selectedPage, setSelectedPage] = useState(1);
    const [totalPage, setTotalPage] = useState(1);
    const [totalCount, setTotalCount] = useState(4);
    const [sortBy, setSortBy] = useState("EndDate");
    const [desc, setDesc] = useState(true);

    let handleVstsButton = (e) => {
        e.stopPropagation()
        let data = {
            postId: vstsLibraryPost.vstsLibraryPostId,
            postType: LibraryPostType.Url,
            action: LibraryPostFileClickAction.Link
        }
        LibraryHelper.openLibraryNoticeDialog(setConfirmDialog, confirmDialog, vstsLibraryPost.vstsLibraryPostNotice, data);
    }

    let setComponentState = (result) => {
        setVstsButtonState(result.data.dashboardVstsButtonState)
        setVstsLibraryPost(result.data.vstsLibraryPostLink)
        setVstsSubscriptions(result.data.items)
        setTotalCount(result.data.totalCount)
        setTotalPage(Math.ceil(result.data.totalCount / PAGE_SIZE))
        setSubtitle(renderSubtitle(result.data.items.length, getCardAlertType(result.data.dashboardExpirationAlert), VSTS_SUBTITLES))
    }

    let onClickVstsAlertIcon = (row) => {
        let data = {
            OrganizationProductSubscriptionId: row.organizationProductSubscriptionId,
            EndDate: row.endDate,
            ToggleOff: row.expirationAlert < EXPIRATION_ALERT.BLUE
        }

        let skipCount = (selectedPage - 1) * PAGE_SIZE;
        trackPromise(
            API.upsertVstsSubscriptionAlert(data, selectedBid, skipCount, sortBy, desc)
                .then((result) => {
                    setComponentState(result)
                })
                .catch((error) => {
                    setPageError(error);
                    alertContext.setGlobalErrorMessage(error.message);
                })
        );
    }

    const fetchData = (page, sortBy, desc) => {
        let skipCount = (page - 1) * PAGE_SIZE;
        trackPromise(
            API.getVstsSubscriptions(selectedBid, skipCount, sortBy, desc)
                .then((result) => {
                    setComponentState(result)
                })
                .catch((error) => {
                    setPageError(error);
                    alertContext.setGlobalErrorMessage(error.message);
                })
        );
    };

    const handlePageChange = (newPage) => {
        setSelectedPage(newPage)
        fetchData(newPage, sortBy, desc);
    };


    useEffect(() => {
        fetchData(selectedPage, sortBy, desc);
    }, [selectedBid]);
    return (
        <>
            <Row>
                <Col>
                    <DashboardAccordion id="dashboard-vsts-subscription-accordion"
                        accordionHeaderActionComponent={<VstsAccordionActionItems handleVstsButton={handleVstsButton} vstsButtonState={vstsButtonState} />}
                        subtitle={subtitle}
                        title={VSTS_TITLE}
                    >
                        <Row className="approved-products-table">
                            <MCSPagedTable
                                size={"compact"}
                                colHeaders={vstsTableHeaders}
                                selectedPage={selectedPage}
                                setSelectedPage={handlePageChange}
                                ordered={sortBy}
                                setOrdered={setSortBy}
                                isDsc={desc}
                                setDsc={setDesc}
                                totalPages={totalPage}
                                pageSize={PAGE_SIZE}
                                totalCount={totalCount}
                                usePagination={true}
                                tableData={
                                    vstsSubscriptions && vstsSubscriptions.map((row, key) => {
                                        return (
                                            <Tr className="row-vstt-even" key={key}>
                                                <Td id={"vsts_subcription_" + key}>VSTS {row.name}</Td>
                                                <Td id={"start_date_" + key}>{row.startDate ? DateHelper.ToFormattedDate(row.startDate) : ""}</Td>
                                                <Td>
                                                    <Row id={"end_date_" + key}>
                                                        {row.expirationAlert < EXPIRATION_ALERT.NONE
                                                            ? <span className="cursor-pointer" onClick={() => onClickVstsAlertIcon(row)}>{getExpirationAlertIcon(row.expirationAlert)}</span>
                                                            : <>{getExpirationAlertIcon(row.expirationAlert)}</>}
                                                        {row.endDate ? DateHelper.ToFormattedDate(row.endDate) : ""}
                                                    </Row>
                                                </Td>
                                            </Tr>
                                        )
                                    })
                                }
                            />
                        </Row>
                        <Row style={totalCount < PAGE_SIZE ? { paddingTop: "20px" } : {}}>
                            <ProductCertificationFootnotes expirationDays={[30, 60, 90]} />
                        </Row>
                    </DashboardAccordion>
                </Col>
            </Row>
            {confirmDialog && (
                <MCSConfirmDialog
                    confirmHandler={LibraryHelper.handleLibraryPostOnClick}
                    confirmDialog={confirmDialog}
                    setConfirmDialog={setConfirmDialog}
                />
            )}
        </>
    )
}

export default VstsSubcriptionsAccordion